<script lang="ts">
  import { Icon, Nav, CenterImage } from '@centerhealth/fe/center-kit';
  import { NavItem } from '@centerhealth/fe/center-kit';
  import { CENTER_SOCIAL_LINKS } from '@centerhealth/fe/center-kit';
  import { queryParameters } from '@centerhealth/fe/stores';
  import { createSource, ISrcSetData } from '@centerhealth/fe/images';

  const imageObject: ISrcSetData = {
    sourceUrl: '/assets/branding/logo.webp',
  };
  export let navItems: NavItem[] = [];

  // Add type to query parameters
  let queryParams: string;
  $: queryParams = $queryParameters;

  // update nav items if query params are found
  $: navItemsWithQuery = navItems.map((navItem) => ({
    ...navItem,
    link: `${navItem.link}${queryParams}`,
  }));
</script>

<footer class="mt-6 py-5 xl:pb-7">
  <div
    class="container mx-auto flex flex-col gap-y-7 justify-between items-center xxl:flex-row xxl:gap-0"
  >
    <a href={`/${queryParams}`}>
      <CenterImage>
        <img
          width="240"
          height="49"
          class="w-60"
          src={createSource(imageObject.sourceUrl)}
          alt="Center Health"
        />
      </CenterImage>
    </a>
    <Nav navItems={navItemsWithQuery} gap="small" />
    <div class="flex">
      {#each CENTER_SOCIAL_LINKS as { name, href }}
        <Icon {name} {href} customClass="ml-2 opacity-60" size="medium" target="_blank" />
      {/each}
    </div>
  </div>
</footer>
